/* eslint-disable max-lines-per-function */
import { Button } from '@e2n/ui';
import { Avatar, AvatarFallback } from '@e2n/ui';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import {
  faCalendarExclamation,
  faFileContract,
  faPlusLarge,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Anstellungstyp } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/anstellungstyp';
import { useFristenContext } from './context/useFristenContext';
import dayjs from 'dayjs';
import { FristenGrund } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/fristenGrund';
import { useTranslation } from 'react-i18next';

export function FristenSuggestions() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { setOpenCreateSheet, setCreateSheetDefaultValues } =
    useFristenContext();
  const anstellungstypForSuggestion = [
    Anstellungstyp.VOLLZEIT,
    Anstellungstyp.TEILZEIT,
    Anstellungstyp.AZUBI,
  ];
  const hasAnstellungstypForSuggestion = anstellungstypForSuggestion.some(
    (anstellungstyp) =>
      anstellungstyp ===
      form.state.values.anstellungsverhaeltnis.anstellung.anstellungstyp,
  );
  const hasBefristung =
    form.state.values.anstellungsverhaeltnis.anstellung.befristung;

  if (!hasAnstellungstypForSuggestion && !hasBefristung) return null;

  return (
    <div className="flex flex-col gap-4 w-full">
      <h3 className="text-neutrals-900 text-base font-bold leading-6">
        {t(
          'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.fristenSuggestions.title',
        )}
      </h3>
      <div className="grid md:grid-cols-2 gap-4">
        {hasAnstellungstypForSuggestion && (
          <Button
            variant={'ghost'}
            size={'lg'}
            type="button"
            className="bg-neutrals-200 text-primary-blue-600 flex gap-2 p-4 rounded-md items-center h-auto cursor-pointer"
            onClick={() => {
              setCreateSheetDefaultValues({
                fristdatum: dayjs().add(3, 'month').toISOString(),
                grund: FristenGrund.PROBEZEIT_ENDE,
                erinnerungsZeit: [],
              });

              setOpenCreateSheet(true);
            }}>
            <Avatar className="size-8">
              <AvatarFallback className="bg-primary-orange-300">
                <FontAwesomeIcon
                  icon={faCalendarExclamation}
                  className="size-3"
                />
              </AvatarFallback>
            </Avatar>
            <span className="text-neutrals-900 text-sm font-semibold leading-5">
              {t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.fristenSuggestions.probezeit',
              )}
            </span>
            <FontAwesomeIcon icon={faPlusLarge} className="ml-auto" />
          </Button>
        )}
        {hasBefristung && (
          <Button
            variant={'ghost'}
            size={'lg'}
            type="button"
            className="bg-neutrals-200 text-primary-blue-600 flex gap-2 p-4 rounded-md items-center h-auto cursor-pointer"
            onClick={() => {
              setCreateSheetDefaultValues({
                fristdatum:
                  form.state.values.anstellungsverhaeltnis.anstellung
                    .befristung,
                grund: FristenGrund.ARBEITSVERTRAG_ENDE,
                erinnerungsZeit: [],
              });
              setOpenCreateSheet(true);
            }}>
            <Avatar className="size-8">
              <AvatarFallback className="bg-secondary-cyan-200">
                <FontAwesomeIcon icon={faFileContract} className="size-3" />
              </AvatarFallback>
            </Avatar>
            <span className="text-neutrals-900 text-sm font-semibold leading-5">
              {t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.fristenSuggestions.vertragsende',
              )}
            </span>
            <FontAwesomeIcon icon={faPlusLarge} className="ml-auto" />
          </Button>
        )}
      </div>
    </div>
  );
}
